import styled from "styled-components";
import BadgeBase from "../../BadgeBase/BadgeBase";
import {
	MemberShipBadgeColors,
	MembershipBadgeVariantForegroundColors,
	StyledMembershipBadgeProps,
} from "./MembershipBadge.types";

const backgroundColorMapping: MemberShipBadgeColors = {
	blue: "primary_accent_600",
	silver: "neutral_200",
	gold: "tertiary_2_500",
	platinum: "primary_accent_100",
	black: "black",
	"non-member": "secondary_3_600",
};

const colorMapping: MembershipBadgeVariantForegroundColors = {
	blue: "fg_light_1",
	silver: "fg_dark_1",
	gold: "fg_dark_1",
	platinum: "fg_dark_1",
	black: "fg_light_1",
	"non-member": "fg_light_1",
};

const StyledMembershipBadge = styled(
	({ variant, ...props }: StyledMembershipBadgeProps) => (
		<BadgeBase
			backgroundColor={backgroundColorMapping[variant]}
			color={colorMapping[variant]}
			iconColor={colorMapping[variant]}
			{...props}
		/>
	)
)<StyledMembershipBadgeProps>``;

export default StyledMembershipBadge;
